import { Link } from 'react-router-dom';
import { Slide } from 'react-awesome-reveal';
import { Box, Stack, Typography } from '@mui/material';
import Navbar from '../navbar/Navbar';
import sectionConstants from '../constants/SectionConstants';
import SectionA from './componenets/SectionA';
import SectionB from './componenets/SectionB';
import SectionC from './componenets/SectionC';
import Footer from '../footer/FooterSection';
import './About.scss';

const About = () => (
  <Box className='about-page'  >
    <Box  id="top" className='about-image'>
      <Box className='nav-section '>
        <Navbar />
      </Box>
      <Stack className='about-heading' spacing={2}>
        <Typography className='about-heading-data1'>
          <Slide>{sectionConstants.AboutUss}</Slide>
        </Typography>
        <Typography className='about-heading-data2'>
          <Stack direction='row' spacing={1}>
            <Slide>
              <Link to='/'>
                <Typography className='about-heading-data2'>
                  {sectionConstants.Home}
                </Typography>
              </Link>
            </Slide>
            /
            <Slide>
              <Link to='/about'>
                <Typography className='about-heading-data2'>
                  {sectionConstants.AboutUs}
                </Typography>
              </Link>
            </Slide>
          </Stack>
        </Typography>
      </Stack>
    </Box>
    <Box>
      <SectionA />
      <SectionB />
      <SectionC />
    </Box>
    <Footer />
  </Box>
);

export default About;
